import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { Ajuste } from 'src/app/Models/ajuste/ajuste';
import { TipoOperacion } from 'src/app/Models/tipooperacion/tipo-operacion';
import { Detajuste } from 'src/app/Models/ajuste/detajuste/detajuste';
import { Motivo } from 'src/app/Models/motivo/motivo';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { ComprasArticuloComponent } from '../compras/compras-detcompra/compras-detcompra.component';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { Title } from '@angular/platform-browser';
import { AddAjusteComponent } from './add-ajuste/add-ajuste.component';
import { Filtro } from 'src/app/Models/filtro/filtro';

@Component({
  selector: 'app-ajuste',
  templateUrl: './ajuste.component.html',
  styleUrls: ['./ajuste.component.css']
})
export class AjusteComponent implements OnInit {
  @ViewChild('btnshow', null) btnshowcompr: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('listadetajuste', null) listadetajuste: ElementRef;
  @ViewChild(ComprasArticuloComponent, null) public frmcomprasdetalles: ComprasArticuloComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion',null) txtdireccion:ElementRef;
  @ViewChild(AddAjusteComponent, null) newajuste: AddAjusteComponent;
  public usuario: Usuario = new Usuario();
  public ajuste:Ajuste = new Ajuste();
  public tipos_opera:TipoOperacion[] = [];
  public ajustes: any[] = [];
  public detajustes:Detajuste[] = [];
  public motivos:Motivo[] = [];
  public detajuste:Detajuste = new Detajuste();
  public articulo:Articulo = new Articulo();
  public monedas:Moneda[] = [];
  public alertType:AlertType = new AlertType();
  public options:ALertOption= new ALertOption();
  public isadddetajuste:boolean = false;
  public index:number=0;
  public numitem:number=0;
  public tipo_filtro:number=0;
  public filtro:Filtro= new Filtro();
  public pagarticulo:any;
  constructor(private title: Title,private data: DataService, private notify: NotifyService,private auth:AuthService,private route:Router) { }

  ngOnInit() {
    this.title.setTitle('Documentos de almacen | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    
    this.filtro.idsucursal = this.data.getSucursalId()
    this.mostrarFiltro()
  }

  

  getAjustes() {
    this.data.GetSimple(this.data.api.ajuste).subscribe(r => {
      console.log(r);

      this.ajustes = r;
    })
  }
  reiniciarFiltro() {
    this.filtro = {
        ...this.reiniciarObjetoFiltro(this.filtro), // Copia los campos tipofecha, fecini, fecfin
    };
  }

  // Función para reiniciar el objeto filtro manteniendo tipofecha, fecini, fecfin
  private reiniciarObjetoFiltro(obj: Filtro): Partial<Filtro> {
      const { tipofecha, fecini, fecfin } = obj;
      return { tipofecha, fecini, fecfin };
  }


  mostrarFiltro(){
    console.log(this.filtro);
    this.data.Post('filtrardoc/Ajuste',this.filtro).subscribe(r=>{
      console.log(r);
      if (r.status==='error') {
        this.ajustes=[];
        //this.data.notify(r.message,"Error",this.alertType.error);
        console.log(r.message);
      }else{
        this.ajustes=r.data;
      }
      
      
    }),(e=>{this.data.notify(e.message,"Error",this.alertType.error);})
    
  }


  showfrmajuste() {
    this.newajuste.ajuste = new Ajuste()
    this.newajuste.filtroguia = new Filtro()
    //this.newajuste.detfactus = []
    this.newajuste.isedit = false
    this.newajuste.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }

  showViewajuste(i) {
    console.log(i);
    this.newajuste.ajuste = new Ajuste()
    this.newajuste.detajustes = []
    this.newajuste.ajuste = i
    this.newajuste.isedit = true
    
    this.newajuste.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }
  // @ViewChild('btnshow', null) btnshowcompr: ElementRef;
  // @ViewChild('btnclose', null) btnclose: ElementRef;
  // @ViewChild('listadetajuste', null) listadetajuste: ElementRef;
  // @ViewChild(ComprasArticuloComponent, null) public frmcomprasdetalles: ComprasArticuloComponent;
  // @ViewChild(AlertComponent, null) alert: AlertComponent;
  // @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  // @ViewChild(InfoComponent, null) info: InfoComponent;
  // @ViewChild('txtdireccion',null) txtdireccion:ElementRef;
  // public usuario: Usuario = new Usuario();
  // public ajuste:Ajuste = new Ajuste();
  // public tipos_opera:TipoOperacion[] = [];
  // public detajustes:Detajuste[] = [];
  // public motivos:Motivo[] = [];
  // public detajuste:Detajuste = new Detajuste();
  // public articulo:Articulo = new Articulo();
  // public monedas:Moneda[] = [];
  // public alertType:AlertType = new AlertType();
  // public options:ALertOption= new ALertOption();
  // public isadddetajuste:boolean = false;
  // public index:number=0;
  // public numitem:number=0;
  // public pagarticulo:any;
  // constructor(private title: Title,private data: DataService, private notify: NotifyService,private auth:AuthService,private route:Router) { }

  // ngOnInit() {
  //   this.title.setTitle('Documentos de almacen | Sistema de ventas');
  //   this.usuario = this.auth.getCurrentUser();
  //   this.CalcularSumaTotal();
  //   this.GetTiposOperaciones();
  //   this.GetMotivos();
  //   this.getMonedas();
    
    
  // }

  // getMonedas(){
  //   this.data.GetSimple(this.data.api.moneda).subscribe(r=>{
  //     console.log(r);
  //     this.monedas=r;
  //   })
  // }

  // getTipocambio(){
  //   this.data.GetTipoCambio(this.ajuste.fecha).then(r=>{
  //     console.log(r);
  //     this.ajuste.tcambio=r.venta;
  //   })
  // }

  // GetTiposOperaciones(){
  //   this.data.GetSimple(this.data.api.tip_opetbl12).subscribe(r=>{
  //     this.tipos_opera = r;
  // }),(e=>{console.log(e.eror.text)});
  // }

  // GetMotivos(){
  //   this.data.GetSimple(this.data.api.motivo).subscribe(r=>{
  //     this.motivos = r;
  // }),(e=>{console.log(e.eror.text)});
  // }

  // ShowNewDetcompra(){
    
  //   this.frmcomprasdetalles.articulo = null;
  //   this.frmcomprasdetalles.show(() => {
  //       let newdetalle:Detajuste = new Detajuste();
        
  //       //this.articulo = this.frmcomprasdetalles.articulo;
  //       if (this.frmcomprasdetalles.articulo != null ) {
  //           newdetalle.item=this.detajustes.length+1;
  //           newdetalle.articulo = this.frmcomprasdetalles.articulo;
  //           newdetalle.idproduct = this.frmcomprasdetalles.articulo.idproduct;
  //           newdetalle.valunit = this.frmcomprasdetalles.articulo.ultcosto;
  //           this.detajustes.push(newdetalle);   
  //       }
  //   });
  // }
  
  // UpdateDetCompra(index: number, field: string, value: string) {
  //   this.detajustes[index][field] = value;
  //   if (field === 'cantidad' || field === 'texto' || field === 'precio') {
  //     this.PrepararAjuste(index);
  //   }
  //   this.CalcularSumaTotal();
  // }

  // async GuardarDetalle(){
  //   console.log(this.detajuste);
  //   if (this.detajuste.idproduct==undefined){
  //     this.data.notify("Elemento vacio","Error",this.alertType.warning);}
  //   else{
  //     this.detajuste.n = this.index
  //     this.index++
  //     this.detajustes.push(this.detajuste);
  //     this.CalcularSumaTotal();
  //     this.isadddetajuste=false
  //   }
  //     //this.guardarArticulo();
  // }

  // async CancelarDetalle(){
  //   this.isadddetajuste=false
  // }

  // ShowNewdetajuste(){
    
  //   this.frmcomprasdetalles.articulo = null;
  //   this.frmcomprasdetalles.show(() => {
  //       this.articulo = this.frmcomprasdetalles.articulo;
        
  //       if (this.articulo != null ) {
  //           this.detajuste.articulo = this.articulo
  //           this.detajuste.idproduct = this.articulo.idproduct
  //           this.detajuste.valunit = this.articulo.ultcosto
  //       }
  //   });
  // }

  // CalcularTotal(item:Detajuste){
  //   if (item.valunit!=undefined && item.cantidad!=undefined) {
  //     item.total = item.valunit * item.cantidad
  //   }
  // }

  // CalcularSumaTotal(){
  //   let sumatotal = 0;
  //   this.detajustes.forEach(detalle => {
  //     sumatotal+=(+detalle.total);
  //   });
  //   this.ajuste.total = sumatotal
  // }

  // PrepararAjuste(index:number){
  //   const item = this.detajustes[index];
  //   this.CalcularTotal(item);
  //   this.ajuste.idsucursal='1';
  //   this.ajuste.estado = 'EMI';
  //   // const parsedDate = moment(this.ajuste.fecha, 'DD-MM-YYYY');
  //   // this.ajuste.fecha = parsedDate.format('YYYY-MM-DD');
  // }

  // async GuardarAjuste(){
  //   console.log(this.detajustes);

  //   await this.data.AsyncPost(this.data.api.ajuste,this.ajuste).then(r=>{
  //     if (r.idajuste !=null) {
  //       console.log("cabezera guardada");
        
  //       console.log(r);
  //       this.detajustes.forEach(detajuste => {
          
  //         detajuste.idajuste = r.idajuste
  //         this.data.AsyncPost(this.data.api.detajuste,detajuste).then(d=>{
            
  //           console.log(d);
  //           if (d.length>0) {
  //             console.log("detalle guardado");
  //             console.log(d);
  //           }
  //         }).catch(e=> console.log(e))
  //       });
  //       this.data.notify("Elemento guardado","Exito",this.alertType.success,this.options,this.refresh());
        
  //     }else{
  //       console.log("error");
  //       console.log(r);
        
  //     }
  //   }).catch(()=>this.data.notify("Datos vacios o invalidos","Error",this.alertType.warning,this.options,this.ajuste.fecha=null))
    
  // }
  
  // refresh(): Function {
  //   this.ajuste=new Ajuste();
  //   this.detajustes=[];
  //   return null
  // }
  

  // async DeleteDetCompra(indice:number){
  //   console.log(indice);
  //   this.detajustes.splice(indice,1);
  //   this.CalcularSumaTotal();
  // }
}
